import { render, staticRenderFns } from "./VariantItemFlat.vue?vue&type=template&id=b5fecfca&scoped=true"
import script from "./VariantItemFlat.vue?vue&type=script&lang=js"
export * from "./VariantItemFlat.vue?vue&type=script&lang=js"
import style0 from "./VariantItemFlat.vue?vue&type=style&index=0&id=b5fecfca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fecfca",
  null
  
)

export default component.exports